import styled from "@emotion/styled";
import { Flex } from "@radix-ui/themes";
import { theme } from "@themes/themes";

export const Container = styled(Flex)`
  width: 100%;
  max-width: 100%;
  height: 48px;
  align-items: center;
  gap: 10px;
  background-color: ${theme.color("gray-2")};
  border: 1px solid ${theme.color("gray-6")};
  border-radius: 8px;
  padding: 0 14px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const EmptyText = styled.span`
  ${theme.font.body14};
  color: ${theme.color("gray-8")};
  margin-left: 12px;
`;

export const FavoritesScroll = styled(Flex)`
  gap: 8px;
  overflow-x: auto;
  flex: 1;
  min-width: 0;
  align-items: center;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.color("gray-7")};
    border-radius: 4px;

    &:hover {
      background: ${theme.color("gray-8")};
    }
  }
`;

export const MarketCard = styled(Flex)`
  align-items: center;
  padding: 6px 14px;
  background-color: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  border: 1px solid transparent;
  flex-shrink: 0;

  &:hover {
    background-color: ${theme.color("gray-4")};
  }

  &:active {
    background-color: ${theme.color("gray-5")};
    border-color: ${theme.color("accent-7")};
    transform: scale(0.98);
  }
`;

export const TokenIcon = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 100%;
`;

export const PriceText = styled.span<{ color: string }>`
  font-family: "IBM Plex Mono", monospace;
  font-size: 14px;
  font-weight: 500;
  color: ${({ color }) => theme.color(color as any)};
`;

export const PercentText = styled.span<{ color: string }>`
  font-family: "IBM Plex Mono", monospace;
  font-size: 14px;
  font-weight: 500;
  color: ${({ color }) => theme.color(color as any)};
`;

export const PercentBadge = styled(Flex)<{ negative: boolean; neutral?: boolean }>`
  align-items: center;
  padding: 2px 8px;
  background-color: ${({ negative, neutral }) =>
    neutral ? theme.color("gray-4") : negative ? theme.color("red-weak") : theme.color("green-weak")};
  border: 1px solid ${({ negative, neutral }) =>
    neutral ? theme.color("gray-6") : negative ? theme.color("red-medium") : theme.color("green-medium")};
  border-radius: 4px;
`;
